module.exports = __webpack_public_path__ + "media/assets/images/kasai_ranking_first_view-83f2c95462b7afd2cd7b1fe94a159e02.png";